<template>
    <v-card class="elevation-12">
        <v-toolbar dark color="primary">
            <v-toolbar-title>{{trans('auth-pages.confirm.title') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <error-badge v-model="error"></error-badge>
            {{ trans('auth-pages.confirm.text') }}
            <v-form method="post" :action="action">
                <v-text-field
                    :label="trans('auth-pages.confirm.label')"
                    type="password"
                    v-model="password"
                    prepend-icon="vpn_key"
                    required
                    autocomplete="current-password"
                    ></v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-row justify="space-between text-center">
                <v-col>
                    <v-btn type="submit"
                        color="primary"
                        :disabled="!canSubmit"
                        ><v-icon left>send</v-icon>{{trans('auth-pages.confirm.submit-btn')}}</v-btn>
                </v-col>
                <v-col>
                    <v-btn text
                        v-if="resetPassword"
                        :href="resetPassword"
                        >{{trans('auth-pages.confirm.forgot-btn')}}</v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    props: {
        resetPassword:{},
        action:{required:true,}
    },
    data() {
        return {
            password:'',
        };
    },
    computed: {
        canSubmit(){return this.password && this.password.length>6;},
    },
    methods: {},
    watch: {},
    filters: {}
}
</script>
